import { getAuth } from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import { MultipleQueryTypesense } from "../../../Typesense";
import getFiltersString from "./getFiltersString";
import { useContext } from "react";
import { resultsContext } from "../Properties";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../../firebase";
const limitForDocs = 10;
export function usePublicProperties(
  Type,
  FiltersParams,
  areFiltersSetToDefault
) {
  const setResult = useContext(resultsContext);
  const [Properties, setProperties] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [paginationIndex, setPaginationIndex] = useState(1);
  const lastPublicSnapshot = useRef("*");

  const [Reset, setReset] = useState(true);

  const reset = () => {
    setProperties([]);
    setHasMore(true);
    setPaginationIndex(1);
    setReset(!Reset);
  };

  const fetchPropertiesFromTypesense = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const FilterStrings = getFiltersString(FiltersParams);
        let properties = (
          await MultipleQueryTypesense(
            {
              searches: [
                {
                  filter_by: `${FilterStrings[0]}&& is_deleted:=false`,
                },
                {
                  filter_by: `${FilterStrings[1]}&& is_deleted:=false`,
                },
              ],
            },
            {
              collection: "properties",
              q: "public",
              query_by: "status",
              per_page: limitForDocs,
              page: paginationIndex,
              sort_by: "sharedAt:desc",
            }
          )
        ).map(({ document }) => document);

        let TotalProperties = [...Properties, ...properties];
        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        setPaginationIndex(paginationIndex + 1);
        if (properties.length < limitForDocs) setHasMore(false);

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPropertiesFromFirestoreFirst = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,
          where("status", "==", "public"),
          where("is_deleted", "==", false),
          orderBy("sharedAt", "desc"),
          limit(limitForDocs)
        );
        const publicProperties = (await getDocs(q)) || [];

        const pProperties = publicProperties.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });
        lastPublicSnapshot.current =
          publicProperties.docs[publicProperties.docs.length - 1];

        let TotalProperties = [...Properties, ...pProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        setPaginationIndex(paginationIndex + 1);
        if (pProperties.length < limitForDocs) {
          setHasMore(false);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPropertiesFromFirestoreAgain = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,

          where("status", "==", "public"),
          where("is_deleted", "==", false),
          orderBy("sharedAt", "desc"),
          startAfter(lastPublicSnapshot.current ?? ""),
          limit(limitForDocs)
        );
        const publicProperties = (await getDocs(q)) || [];

        const pProperties = publicProperties.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });
        lastPublicSnapshot.current =
          publicProperties.docs[publicProperties.docs.length - 1];

        let TotalProperties = [...Properties, ...pProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        setPaginationIndex(paginationIndex + 1);
        if (pProperties.length < limitForDocs) {
          setHasMore(false);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPropertiesFromFirestore = () => {
    if (paginationIndex === 1) {
      fetchPropertiesFromFirestoreFirst();
    } else {
      fetchPropertiesFromFirestoreAgain();
    }
  };
  const fetchProperties = () => {
    if (areFiltersSetToDefault()) {
      fetchPropertiesFromFirestore();
    } else {
      fetchPropertiesFromTypesense();
    }
  };

  useEffect(() => fetchProperties(), [Reset]);
  useEffect(() => reset(), [FiltersParams]);
  useEffect(() => fetchProperties(), []);

  return [Properties, fetchProperties, hasMore];
}
